import createReactComponent from '../createReactComponent';
export default createReactComponent('text-justify', 'TextJustify', [["path",{"d":"M4.5 6h15m-15 4h15m-15 4h15m-15 4h15","key":"svg-0"}]]);